import { render } from "./Menu.vue?vue&type=template&id=c039fcd8"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Menu.vue?vue&type=style&index=0&id=c039fcd8&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__